export default __webpack_public_path__ + "static/media/pipe2.c1e9ffbc.jpg";